import { Controller, useForm } from 'react-hook-form';
import { UpdateContractForm } from '../models/contractModel';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useEffect } from 'react';
import { Button, Col, Form, FormGroup, Input, Row } from 'reactstrap';

interface Props {
  contract: UpdateContractForm;
  handleUpdate: (form: UpdateContractForm) => void;
}

const ContractForm = ({ contract, handleUpdate }: Props) => {
  const {
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    reset,
  } = useForm<UpdateContractForm>({
    resolver: yupResolver(
      yup
        .object({
          price: yup.number().required('Requerido'),
          has_rental_management: yup.boolean(),
        })
        .required(),
    ),
  });

  useEffect(() => {
    if (contract) {
      reset({
        price: contract.price,
        has_rental_management: contract.has_rental_management,
      });
    }
  }, [contract]);

  return (
    <Form>
      <Row>
        <Col md={8}>
          <FormGroup>
            <label className="form-control-label" htmlFor="price">
              Valor
            </label>
            <Controller
              name="price"
              control={control}
              defaultValue={0}
              render={({ field }) => (
                <Input
                  className={errors.price?.message && 'is-invalid'}
                  {...field}
                  type="number"
                  placeholder="Ingresa el monto"
                  step="any"
                />
              )}
            />
            <h5 className="text-danger">{errors.price?.message}</h5>
          </FormGroup>
          <FormGroup>
            <Controller
              name="has_rental_management"
              control={control}
              render={({ field: { onChange, value, ...field } }) => (
                <Input
                  {...field}
                  id="has_rental_management"
                  type="checkbox"
                  className={
                    errors.has_rental_management?.message && 'is-invalid'
                  }
                  style={{ marginLeft: 0 }}
                  onChange={(e) =>
                    setValue('has_rental_management', e.target.checked)
                  }
                  defaultChecked={contract?.has_rental_management}
                />
              )}
            />

            <label
              htmlFor="has_rental_management"
              className="form-control-label ml-3"
            >
              Tiene rental managment
            </label>
            <h5 className="text-danger">
              {errors.has_rental_management?.message}
            </h5>
          </FormGroup>
          <Button
            color="info"
            onClick={() => {
              handleSubmit(handleUpdate)();
            }}
          >
            Actualizar contrato
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default ContractForm;
